<template>
  <div>
    <institutions-list
      :institutions="financialInstitutions"
      @add-institution="addInstitution()"
      @delete-institution="deleteInstitution($event)"
      @edit-institution="editInstitution($event)"
    />
    <a-drawer
      :title="
        selectedInstitution
          ? selectedInstitution.name
          : 'Add Financial institution'
      "
      width="600"
      placement="right"
      :visible="showEditInstitutionDrawer"
      @close="onEditInstitutionDrawerClosed()"
    >
      <edit-institution
        :institution="selectedInstitution"
        @institution-saved="onInstitutionSaved($event)"
        @cancel-button-clicked="onEditInstitutionDrawerClosed()"
      />
    </a-drawer>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import InstitutionsList from '../components/FinancialInstitutions/InstitutionsList.vue'
import EditInstitution from '../components/FinancialInstitutions/EditInstitution.vue'

export default {
  components: {
    EditInstitution,
    InstitutionsList,
  },
  apollo: {
    financialInstitutions: {
      client: 'kpis',
      query: gql`
        query {
          financialInstitutions {
            id
            name
            isin
            currency
          }
        }
      `,
    },
  },
  data() {
    return {
      financialInstitutions: [],
      showEditInstitutionDrawer: false,
      selectedInstitution: null,
    }
  },
  methods: {
    addInstitution() {
      this.selectedInstitution = null
      this.showEditInstitutionDrawer = true
    },
    async deleteInstitution(institutionId) {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($institutionId: Uuid!) {
            deleteFinancialInstitution(institutionId: $institutionId) {
              institutionId
            }
          }
        `,
        variables: {
          institutionId,
        },
      })
      this.$apollo.queries.financialInstitutions.refetch()
    },
    editInstitution(institution) {
      this.selectedInstitution = institution
      this.showEditInstitutionDrawer = true
    },
    onEditInstitutionDrawerClosed() {
      this.selectedInstitution = null
      this.showEditInstitutionDrawer = false
    },
    onInstitutionSaved() {
      this.$apollo.queries.financialInstitutions.refetch()
      this.showEditInstitutionDrawer = false
    },
  },
}
</script>

<style></style>
